module.exports = __webpack_public_path__ + "img/Metal038_1K_Displacement.41650cd4.jpg";